// Dashboard.jsx
import React, { useEffect, useState } from "react";
import "./Screens.css";
import { dashboardSummary } from "../../api/UserAPI";
import { useGlobalUI } from "../../context/GlobalUIProvider";
import { useNavigate } from "react-router-dom";
import { transactionFilter } from "../../api/TranscationApi";
import { StatusTag } from "../TransactionsPackage/Transactions";
import { timeAgo } from "../../Custom/Custom";

const transactions = [
  {
    id: "TXN001",
    user: "john@email.com",
    status: "completed",
    amount: "$245.00",
    ago: "2 min ago",
  },
  {
    id: "TXN002",
    user: "sarah@email.com",
    status: "pending",
    amount: "$89.50",
    ago: "5 min ago",
  },
  {
    id: "TXN003",
    user: "mike@email.com",
    status: "completed",
    amount: "$1,200.00",
    ago: "8 min ago",
  },
  {
    id: "TXN004",
    user: "lisa@email.com",
    status: "failed",
    amount: "$67.25",
    ago: "12 min ago",
  },
];

const alerts = [
  {
    color: "yellow",
    icon: "●",
    msg: "High Volume Alert",
    sub: "Transaction volume 15% above normal • 5 min ago",
  },
  {
    color: "red",
    icon: "●",
    msg: "Failed Login Attempts",
    sub: "Multiple failed logins from IP 192.168.1.1 • 12 min ago",
  },
];

export default function Dashboard() {
  const { message, showLoader, hideLoader } = useGlobalUI();
  const navigate = useNavigate();
  const [transactions, setTransactions] = useState([]);

  const [dashboardCount, setDashboardCount] = useState(null);
  const [pageNo, setPageNo] = useState(0); // backend pageNo is 0-based
  const [pageSize, setPageSize] = useState(4);

  useEffect(() => {
    summaryDetails();
    fetchTransactions();
  }, []);

  const summaryDetails = () => {
    showLoader();
    dashboardSummary()
      .then((response) => {
        if (response.data.data) {
          setDashboardCount(response.data.data);
        }
      })
      .catch((error) => {
        console.log("error", error);
      })
      .finally(() => hideLoader());
  };

  const fetchTransactions = () => {
    showLoader();

    // Prepare payload matching backend filter model
    const payload = {
      pageNo,
      pageSize,
      transactionStatus: null,
      transactionType: null,
      searchBy: undefined,
      startDate: undefined,
      endDate: undefined,
      // fromUserId, toUserId can also be added here if needed
    };

    transactionFilter(payload)
      .then((res) => {
        const data = res.data.data || {};

        setTransactions(data.content || []);
      })
      .catch((err) => {
        message.error("Failed to fetch transactions");
        console.error(err);
      })
      .finally(() => hideLoader());
  };

  const onClickViewAll = () => {
    navigate("/admin/transactions");
  };

  const stats = [
    {
      label: "Total Users",
      value: dashboardCount?.activeUserCount,
      sub: "+12.5%",
      color: "blue",
    },
    {
      label: "Active Wallets",
      value: dashboardCount?.activeWalletCount,
      sub: "+8.2%",
      color: "green",
    },
    {
      label: "Daily Transactions",
      value: dashboardCount?.averageDailyTransactions,
      sub: "-3.1%",
      color: "red",
    },
    {
      label: "Pending KYC",
      value: dashboardCount?.pendingKycCount,
      sub: "+5.7%",
      color: "indigo",
    },
  ];

  return (
    <div className="dashboard-content">
      <h1 className="content-title">Dashboard</h1>
      <div className="dashboard-stats-row">
        {stats.map((s, i) => (
          <div className={`stats-card stats-${s.color}`} key={s.label}>
            <span className="stats-value">{s.value}</span>
            <span className="stats-label">{s.label}</span>
            <span className="stats-sub">{s.sub}</span>
          </div>
        ))}
      </div>
      <div className="dashboard-grid">
        <div className="dashboard-transactions">
          <div className="trans-header">Recent Transactions</div>
          <table className="trans-table">
            <thead>
              <tr>
                <th>Sender</th>
                <th>Reciever</th>
                <th>Status</th>
                <th className="right">Amount</th>
                <th className="right">Time Ago</th>
              </tr>
            </thead>
            <tbody>
              {transactions.map((tx) => (
                <tr key={tx.id} className="trans-row">
                  <td>{tx.fromUser?.mobileNo || "-"}</td>
                  <td>{tx.toUser?.mobileNo || "-"}</td>
                  <td className="left">
                    {<StatusTag status={tx.transactionStatus} />}
                  </td>
                  <td className="right">{tx.transactionAmount}</td>
                  <td className="right">{timeAgo(tx.createdDate)}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <button className="view-link" onClick={onClickViewAll}>
            View All Transactions
          </button>
        </div>
        <div className="dashboard-alerts">
          <div className="alerts-header">System Alerts</div>
          {alerts.map((alert, i) => (
            <div className={`alert-bar alert-${alert.color}`} key={i}>
              <span className="alert-dot">{alert.icon}</span>
              <div>
                <div className="alert-msg">{alert.msg}</div>
                <div className="alert-sub">{alert.sub}</div>
              </div>
            </div>
          ))}
          <button className="view-link">View All Alerts</button>
        </div>
      </div>
    </div>
  );
}
